/* Anonymous (cookieless) analytics and its opt-out.

   A visitor who declines or ignores the cookie banner is still counted, but
   cookielessly: PostHog's `cookieless_mode: "on_reject"` stores nothing on the
   device and derives a daily-rotating hash on PostHog's servers, so the visit
   can't be linked across days or to a person. This relies on the UK analytics
   exemption (Data (Use and Access) Act 2025, in force 5 Feb 2026): statistics
   about our own site only, with a simple way to object at any time. That way
   is the footer toggle, which stores the objection below.

   Storing the objection is strictly necessary to honour it. If storage is
   unavailable we can't remember a "no", so we fail closed and treat the
   visitor as opted out. */

export const ANON_ANALYTICS_OFF_KEY = "ll_anon_analytics_off";

export function isAnonAnalyticsOff(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(ANON_ANALYTICS_OFF_KEY) === "1";
  } catch {
    return true;
  }
}

export function setAnonAnalyticsOff(off: boolean): void {
  try {
    if (off) window.localStorage.setItem(ANON_ANALYTICS_OFF_KEY, "1");
    else window.localStorage.removeItem(ANON_ANALYTICS_OFF_KEY);
  } catch {
    // Nothing to persist into; isAnonAnalyticsOff() already fails closed.
  }
}
